import React from 'react';
import { cn } from '../../lib/utils';
import { Check } from 'lucide-react';

export function Checkbox({ className, checked, onCheckedChange, id, ...props }) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      id={id}
      onClick={() => onCheckedChange && onCheckedChange(!checked)}
      className={cn(
        "h-4 w-4 rounded border border-border flex items-center justify-center transition flex-shrink-0",
        checked ? "bg-primary border-primary" : "bg-background hover:border-primary/60",
        className
      )}
      {...props}
    >
      {checked && <Check className="h-3 w-3 text-white" strokeWidth={3} />}
    </button>
  );
}
